import { trans } from '@spotahome/soyuz/client';

import Section from './Section';
import EnvelopeIcon from './Icons/EnvelopeIcon';
import ClockIcon from './Icons/ClockIcon';
import KnittedIcon from './Icons/KnittedIcon';

import './Guarantees.scss';

const POINTS = [
  {
    titleKey: 'how_it_works.guarantees.block1.title',
    textKey: 'how_it_works.guarantees.block1.text',
    renderImage: className => <EnvelopeIcon className={className} />
  },
  {
    titleKey: 'how_it_works.guarantees.block2.title',
    textKey: 'how_it_works.guarantees.block2.text',
    renderImage: className => <ClockIcon className={className} />
  },
  {
    titleKey: 'how_it_works.guarantees.block3.title',
    textKey: 'how_it_works.guarantees.block3.text',
    renderImage: className => <KnittedIcon className={className} />
  }
];

const Guarantees = () => {
  return (
    <div className="hiw-guarantees__wrapper">
      <Section className="hiw-guarantees">
        <div className="hiw-guarantees__title-container">
          <div className="hiw-guarantees__subtitle">
            {trans('how_it_works.spotahome.guarantee').toUpperCase()}
          </div>
          <h2 className="hiw-guarantees__title">
            {trans('how_it_works.guarantees.title')}
          </h2>
          <p>{trans('how_it_works.guarantees.description')}</p>
        </div>
        <div className="hiw-guarantees__points-container">
          {POINTS.map(({ titleKey, textKey, renderImage }) => (
            <div className="hiw-guarantees__point" key={titleKey}>
              {renderImage('hiw-guarantees__point__icon')}
              <div>
                <h3 className="hiw-guarantees__point__title">
                  {trans(titleKey)}
                </h3>
                <p className="hiw-guarantees__point__text">{trans(textKey)}</p>
              </div>
            </div>
          ))}
        </div>
      </Section>
    </div>
  );
};

export default Guarantees;
